<script>
export default {
    name: 'ChartingStockBookmark',
    props: {
        ticker: { type: String, default: '' },
        folderNames: { type: Array, default: () => [] },
        canUseFavorites: { type: Boolean, default: false },
        isMutating: { type: Boolean, default: false },
        expanded: { type: Boolean, default: undefined }
    },
    computed: {
        savedCount() { return this.folderNames.length; },
        description() {
            if (!this.canUseFavorites) return 'Workspaces no disponibles en tu plan';
            if (this.savedCount) return 'Guardado en ' + this.savedCount + (this.savedCount === 1 ? ' workspace' : ' workspaces');
            return 'Guardar en workspaces';
        }
    }
};
</script>

<template>
    <button
        type="button"
        class="charting-stock-bookmark"
        :class="{ 'is-saved': savedCount && canUseFavorites, 'is-restricted': !canUseFavorites }"
        :title="description"
        :aria-label="ticker + ': ' + description"
        aria-haspopup="dialog"
        :aria-expanded="expanded === undefined ? undefined : String(expanded)"
        :disabled="isMutating"
        @click="$emit('click', $event)"
    >
        <i :class="!canUseFavorites ? 'pi pi-lock' : savedCount ? 'pi pi-star-fill' : 'pi pi-star'" aria-hidden="true"></i>
    </button>
</template>

<style scoped>
.charting-stock-bookmark { display: inline-flex; flex: 0 0 auto; align-items: center; justify-content: center; width: 2.25rem; height: 2.25rem; border: 0; border-radius: 0.55rem; padding: 0; background: transparent; color: var(--p-text-muted-color); cursor: pointer; }
.charting-stock-bookmark i { font-size: 1rem; }
.charting-stock-bookmark.is-saved { color: var(--brand-primary); }
.charting-stock-bookmark:hover:not(:disabled) { background: var(--charting-b-hover-bg); }
.charting-stock-bookmark:focus-visible { outline: 2px solid var(--brand-primary); outline-offset: 2px; }
.charting-stock-bookmark:disabled { opacity: 0.5; cursor: wait; }
.charting-stock-bookmark.is-restricted { opacity: 0.65; }
@media (max-width: 699px) { .charting-stock-bookmark { width: 2.75rem; height: 2.75rem; } }
</style>
